import api from "../shared/services/api";
import endPoints from "../shared/services/endPoints";

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api("post", endPoints.UPLOAD_FILE, formData, {}, { "Content-Type": "multipart/form-data", });
  if (res.success) {
    if (res.data) {
      return res.data;
    }
  }
};

export const uploadFiles = async (files) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]);
  }
  const res = await api("post", endPoints.UPLOAD_FILES, formData, {}, { "Content-Type": "multipart/form-data", });
  if (res.success) {
    if (res.data) {
      return res.data;
    }
  }
};
